module.exports = __webpack_public_path__ + "img/13d.5aa99cd6.png";